import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";

// Pyetjet dhe përgjigjet e reja për Sanitär & Heizung
const faqs = [
  {
    question: "Was tun bei einem Wasserrohrbruch?",
    answer: "Drehen Sie sofort den Hauptwasserhahn zu (meist im Keller oder Bad), um den Wasserschaden zu begrenzen. Schalten Sie Stromquellen im betroffenen Bereich ab und rufen Sie uns umgehend an."
  },
  {
    question: "Wie oft sollte die Heizung gewartet werden?",
    answer: "Wir empfehlen eine jährliche Wartung vor der Heizperiode. Das sichert die Effizienz, senkt Heizkosten und verlängert die Lebensdauer Ihrer Anlage."
  },
  {
    question: "Bieten Sie komplette Badsanierungen an?",
    answer: "Ja, absolut. Wir begleiten Sie von der Planung bis zur Fertigstellung. Wir koordinieren alle Arbeiten, sodass Sie Ihr neues Bad 'schlüsselfertig' erhalten."
  },
  {
    question: "Sind Kostenvoranschläge kostenlos?",
    answer: "Eine erste Beratung und Angebotserstellung ist in der Regel kostenlos. Bei aufwendigen Planungen oder Fehlersuche vor Ort informieren wir Sie transparent über anfallende Kosten."
  },
  {
    question: "Installieren Sie auch Wärmepumpen?",
    answer: "Ja, wir sind auf moderne und energieeffiziente Heizsysteme spezialisiert, einschließlich Wärmepumpen und Solaranlagen für Warmwasser."
  }
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-24 bg-white" id="faq">
      <div className="max-w-[1600px] mx-auto px-6">
        
        {/* Header */}
        <div className="text-center mb-16">
          <p className="font-bold tracking-widest text-xs uppercase mb-4" style={{ color: "#ff4a4a" }}>
            HÄUFIG GESTELLTE FRAGEN
          </p>
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            Wissenswertes & Hilfe
          </h2>
          <p className="text-gray-500 text-lg">
            Hier finden Sie Antworten auf die wichtigsten Fragen zu unseren Dienstleistungen.
          </p>
        </div>

        {/* Accordion List */}
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index} 
              className={`border rounded-2xl transition-all duration-300 overflow-hidden ${
                openIndex === index 
                  ? "bg-white shadow-lg border-[#ff4a4a]" 
                  : "bg-gray-50 border-transparent hover:bg-gray-100"
              }`}
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between p-6 text-left focus:outline-none"
              >
                <span className={`text-lg font-bold transition-colors ${
                  openIndex === index ? "text-gray-900" : "text-gray-700"
                }`}>
                  {faq.question}
                </span>
                
                {/* Icon Wrapper */}
                <div className={`p-2 rounded-full transition-colors ${
                  openIndex === index ? "bg-red-50" : "bg-white"
                }`}>
                  {openIndex === index ? (
                    <Minus className="w-5 h-5" style={{ color: "#ff4a4a" }} />
                  ) : (
                    <Plus className="w-5 h-5 text-gray-400" />
                  )}
                </div>
              </button>

              {/* Smooth Slide Animation using Grid */}
              <div className={`grid transition-[grid-template-rows] duration-300 ease-out ${
                openIndex === index ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
              }`}>
                <div className="overflow-hidden">
                  <p className="px-6 pb-6 text-gray-500 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      
      </div>
    </section>
  );
};

export default FAQ;